import React from 'react';

export const SelectSimples = ({ value, onChange, options, keyValue, keyLabel, placeholder = "Selecione...", disabled = false }) => {
    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <select
                value={value || ""} // Se não tiver valor, fica na opção vazia (placeholder)
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                style={{
                    width: '100%',
                    padding: '11px 30px 12px 10px', // Espaço extra na direita para o X ou Setinha
                    borderRadius: '4px',
                    border: '1px solid #ccc',
                    backgroundColor: '#fff',
                    fontSize: '14px',
                    color: value ? '#333' : '#999', // Cinza se for placeholder, Escuro se selecionado
                    appearance: 'none', // Remove a seta feia padrão do navegador
                    outline: 'none',
                    cursor: disabled ? 'not-allowed' : 'pointer'
                }}
            >
                {/* Opção fantasma para o Placeholder */}
                <option value="" disabled hidden>{placeholder}</option>
                
                {/* Renderizando as opções da API */}
                {options?.map((opt, idx) => (
                    <option key={idx} value={opt[keyValue]}>
                        {opt[keyLabel]}
                    </option>
                ))}
            </select>

            {/* Renderização Condicional do Ícone: Se tem valor mostra o X, senão mostra a Setinha */}
            {value ? (
                <span
                    onClick={(e) => {
                        e.stopPropagation();
                        onChange(""); // Limpa o valor
                    }}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        color: '#ee4b21', // Vermelho para destaque no X
                        fontWeight: 'bold',
                        fontSize: '14px',
                        padding: '2px 5px'
                    }}
                    title="Limpar seleção"
                >
                    ✕
                </span>
            ) : (
                <span
                    style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'none', // O clique passa direto pela seta para abrir o menu
                        color: '#999',
                        fontSize: '12px'
                    }}
                >
                    ▼
                </span>
            )}
        </div>
    );
};